export default {
  main: "Punkty",

  navigation: {
    view_history: "Zobacz historię",
    back_to_users: "Wróć do listy użytkowników"
  },

  list: {
    headers: {
      id: "ID",
      name: "Nazwa",
      email: "Email"
    },
    actions: {
      add_points: "Dodaj punkty",
      view_history: "Zobacz historię punktów użytkownika"
    }
  },

  search: {
    title: "Wyszukiwanie użytkownika",
    user: "Szukaj użytkownika",
    placeholder: "Wpisz imię, nazwisko lub email",
    results: "Wyniki wyszukiwania",
    no_results: "Nie znaleziono użytkowników spełniających kryteria wyszukiwania",
    instructions: "Wyszukaj użytkowników powyżej, aby przyznać punkty",
    error: "Wystąpił błąd podczas wyszukiwania użytkowników"
  },

  filters: {
    date_range: "Zakres dat",
    point_type: "Typ punktów",
    type_manual: "Ręczne",
    type_auto_prework: "Pre-work",
    type_auto_quiz: "Quiz",
    type_auto_task: "Zadanie",
    type_auto_reflection: "Refleksja",
    last_week: "Ostatnie 7 dni",
    last_month: "Ostatnie 30 dni",
    last_quarter: "Ostatni kwartał",
    last_3_months: "Ostatnie 90 dni",
    last_year: "Ostatni rok"
  },

  history: {
    title: "Historia punktów",
    no_history: "Brak historii punktów",
    error: "Wystąpił błąd podczas pobierania historii punktów",
    headers: {
      user: "Użytkownik",
      date: "Data i czas",
      points: "Punkty",
      reason: "Powód",
      awarded_by: "Przyznane przez"
    }
  },

  modal: {
    add_points: {
      title: "Dodaj Punkty",
      user_label: "Użytkownik",
      email_label: "Email",
      points_number: "Liczba punktów",
      reason_label: "Powód",
      program_label: "Program",
      reason_placeholder: "Wprowadź powód przyznania punktów",
      save_button: "Zapisz",
      cancel_button: "Anuluj",
      errors: {
        invalid_points: "Wprowadź dodatnią liczbę całkowitą",
        empty_reason: "Podaj powód przyznania punktów",
        no_program_selected: "Wybierz program"
      }
    }
  },

  notifications: {
    award_success: "Punkty zostały przyznane pomyślnie",
    award_error: "Wystąpił błąd podczas przyznawania punktów",
    fetch_error: "Nie udało się załadować danych o punktach"
  },

  status: {
    no_users: "Brak dostępnych użytkowników",
    users_error: "Wystąpił błąd podczas ładowania użytkowników"
  }
}; 